import {convertToUrlParams} from 'utils'
import baseApi, {provideTag} from './baseApi'

const ratesApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getRates: build.query({
            query: (query) => {
                const params = convertToUrlParams(query)
                return {
                    url: `rates${params}`,
                    method: 'GET',
                }
            },
            transformResponse: (res) => res,
            providesTags: () => provideTag('Rate'),
        }),
        getRate: build.query({
            query: (id) => {
                return {
                    url: `rates/${id}`,
                    method: 'GET',
                }
            },
            transformResponse: (res) => res,
            providesTags: (result) => provideTag('Rate', result),
        }),
        deleteRate: build.mutation({
            query: (id) => {
                return {
                    url: `rates/${id}`,
                    method: 'DELETE',
                }
            },
            transformResponse: (res) => res,
            invalidatesTags: ['Rate'],
        }),
        createRate: build.mutation({
            query: (data) => {
                return {
                    url: `rates`,
                    method: 'POST',
                    body: data,
                }
            },
            transformResponse: (res) => res,
            invalidatesTags: ['Rate'],
        }),
        createRates: build.mutation({
            query: (data) => {
                return {
                    url: `rates/bulk`,
                    method: 'POST',
                    body: data,
                }
            },
            transformResponse: (res) => res,
            invalidatesTags: ['Rate'],
        }),
        editRate: build.mutation({
            query: (data) => {
                return {
                    url: `rates/${data._id}`,
                    method: 'PUT',
                    body: data,
                }
            },
            transformResponse: (res) => res,
            invalidatesTags: ['Rate'],
        }),
        currentRate: build.query({
            query: () => {
                return {
                    url: `rates/current`,
                    method: 'GET',
                }
            },
            transformResponse: (res) => res,
            providesTags: () => provideTag('CurrentRate'),
        }),
    }),
    overrideExisting: false,
})

export default ratesApi

export const {
    useGetRatesQuery,
    useGetRateQuery,
    useDeleteRateMutation,
    useCreateRateMutation,
    useEditRateMutation,
    useCurrentRateQuery,
    useCreateRatesMutation,
} = ratesApi
